"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = exports.actionCreators = void 0;
exports.actionCreators = {
    requestFunction: function (pageload, appUUID, serviceId, method) { return function (dispatch, getState) {
        var appState = getState();
        console.log("start call api");
        if (appState && appState.serviceInApplication && pageload == true && method == "GET") {
            fetch("/v1/" + appUUID + "/sonarServices", {
                method: 'GET'
            })
                .then(function (response) {
                return response.json();
            })
                .then(function (data) {
                dispatch({ type: 'RECEIVE_SERVICEINAPP', model: data, isRegister: false, message: "" });
            })
                .catch(function (error) {
            });
            dispatch({ type: 'REQUEST_SERVICEINAPP', isRegister: false });
        }
        if (appState && appState.serviceInApplication && pageload == true && method == "POST") {
            var body = {
                'app_uuid': appUUID,
                'service_id': serviceId
            };
            fetch("/v1/apps/service/register", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body)
            })
                .then(function (response) {
                return response.json();
            })
                .then(function (data) {
                dispatch({ type: 'RECEIVE_SERVICEINAPP', model: data, isRegister: true, message: "success" });
            })
                .catch(function (error) {
            });
            dispatch({ type: 'REQUEST_SERVICEINAPP', isRegister: true });
        }
        if (appState && appState.serviceInApplication && pageload == true && method == "PUT") {
            console.log("PUT");
            fetch("/v1/apps/service/accept?uuid=" + appUUID + "&serId=" + serviceId, {
                method: 'PUT'
            })
                .then(function (response) {
                return response.json();
            })
                .then(function (data) {
                dispatch({ type: 'RECEIVE_SERVICEINAPP', model: data, isRegister: true, message: "success" });
            })
                .catch(function (error) {
            });
            dispatch({ type: 'REQUEST_SERVICEINAPP', isRegister: true });
        }
        if (appState && appState.serviceInApplication && pageload == true && method == "DELETE") {
            console.log("DELETE");
            fetch("/v1/apps/service/reject?uuid=" + appUUID + "&serId=" + serviceId, {
                method: 'DELETE'
            })
                .then(function (response) {
                return response.json();
            })
                .then(function (data) {
                dispatch({ type: 'RECEIVE_SERVICEINAPP', model: data, isRegister: true, message: "success" });
            })
                .catch(function (error) {
            });
            dispatch({ type: 'REQUEST_SERVICEINAPP', isRegister: true });
        }
    }; }
};
var unloadedState = { isLoading: false, response: undefined, message: "", isRegister: false };
var reducer = function (state, incomingAction) {
    if (state === undefined) {
        return unloadedState;
    }
    var action = incomingAction;
    switch (action.type) {
        case 'REQUEST_SERVICEINAPP':
            return {
                isLoading: false,
                message: "",
                isRegister: action.isRegister
            };
        case 'RECEIVE_SERVICEINAPP':
            return {
                isLoading: true,
                response: action.model,
                message: action.message,
                isRegister: action.isRegister
            };
        default: return state;
    }
};
exports.reducer = reducer;
//# sourceMappingURL=ServiceInApplication.js.map